/**
 * Theme Color Tokens
 *
 * Single source of truth : les valeurs viennent des CSS custom properties
 * définies dans _role-theme.scss à partir des primitives SCSS _colors.scss.
 *
 * Usage : ThemeColors.purple[500]  →  résout var(--ebo-purple-500) au runtime
 */

function cssVar(name: string): string {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

function p(name: string): string {
  return cssVar(`--${name}`);
}

export const ThemeColors = {
  get text()  { return p('ebo-text'); },
  get white() { return p('ebo-white'); },

  purple: {
    get 50()  { return p('ebo-purple-50'); },
    get 100() { return p('ebo-purple-100'); },
    get 200() { return p('ebo-purple-200'); },
    get 300() { return p('ebo-purple-300'); },
    get 400() { return p('ebo-purple-400'); },
    get 500() { return p('ebo-purple-500'); },
    get 600() { return p('ebo-purple-600'); },
    get 700() { return p('ebo-purple-700'); },
    get 800() { return p('ebo-purple-800'); },
    get 900() { return p('ebo-purple-900'); }
  },
  red: {
    get 50()  { return p('ebo-red-50'); },
    get 100() { return p('ebo-red-100'); },
    get 200() { return p('ebo-red-200'); },
    get 300() { return p('ebo-red-300'); },
    get 400() { return p('ebo-red-400'); },
    get 500() { return p('ebo-red-500'); },
    get 600() { return p('ebo-red-600'); },
    get 700() { return p('ebo-red-700'); },
    get 800() { return p('ebo-red-800'); },
    get 900() { return p('ebo-red-900'); }
  },
  grey: {
    get 50()  { return p('ebo-grey-50'); },
    get 100() { return p('ebo-grey-100'); },
    get 200() { return p('ebo-grey-200'); },
    get 300() { return p('ebo-grey-300'); },
    get 400() { return p('ebo-grey-400'); },
    get 500() { return p('ebo-grey-500'); },
    get 600() { return p('ebo-grey-600'); },
    get 700() { return p('ebo-grey-700'); },
    get 800() { return p('ebo-grey-800'); },
    get 900() { return p('ebo-grey-900'); }
  },
  lightBlue: {
    get 50()  { return p('ebo-light-blue-50'); },
    get 100() { return p('ebo-light-blue-100'); },
    get 200() { return p('ebo-light-blue-200'); },
    get 300() { return p('ebo-light-blue-300'); },
    get 400() { return p('ebo-light-blue-400'); },
    get 500() { return p('ebo-light-blue-500'); },
    get 600() { return p('ebo-light-blue-600'); },
    get 700() { return p('ebo-light-blue-700'); },
    get 800() { return p('ebo-light-blue-800'); },
    get 900() { return p('ebo-light-blue-900'); }
  },
  lightPurple: {
    get 50()  { return p('ebo-light-purple-50'); },
    get 100() { return p('ebo-light-purple-100'); },
    get 200() { return p('ebo-light-purple-200'); },
    get 300() { return p('ebo-light-purple-300'); },
    get 400() { return p('ebo-light-purple-400'); },
    get 500() { return p('ebo-light-purple-500'); },
    get 600() { return p('ebo-light-purple-600'); },
    get 700() { return p('ebo-light-purple-700'); },
    get 800() { return p('ebo-light-purple-800'); },
    get 900() { return p('ebo-light-purple-900'); }
  },
  yellow: {
    get 50()  { return p('ebo-yellow-50'); },
    get 100() { return p('ebo-yellow-100'); },
    get 200() { return p('ebo-yellow-200'); },
    get 300() { return p('ebo-yellow-300'); },
    get 400() { return p('ebo-yellow-400'); },
    get 500() { return p('ebo-yellow-500'); },
    get 600() { return p('ebo-yellow-600'); },
    get 700() { return p('ebo-yellow-700'); },
    get 800() { return p('ebo-yellow-800'); },
    get 900() { return p('ebo-yellow-900'); }
  },
  green: {
    get 50()  { return p('ebo-green-50'); },
    get 100() { return p('ebo-green-100'); },
    get 200() { return p('ebo-green-200'); },
    get 300() { return p('ebo-green-300'); },
    get 400() { return p('ebo-green-400'); },
    get 500() { return p('ebo-green-500'); },
    get 600() { return p('ebo-green-600'); },
    get 700() { return p('ebo-green-700'); },
    get 800() { return p('ebo-green-800'); },
    get 900() { return p('ebo-green-900'); }
  },
  semantic: {
    get success() { return p('ebo-semantic-success'); },
    get warning() { return p('ebo-semantic-warning'); },
    get error()   { return p('ebo-semantic-error'); },
    get info()    { return p('ebo-semantic-info'); }
  }
};

